import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.CHAT_MESSAGES_UPDATE
  ],
  removeType: actions.CHAT_MESSAGE_REMOVE,
  entityType: 'chatMessages'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatMessages/byId/reducer.js
 **/